import { render } from "./DashboardPlaceholder.vue?vue&type=template&id=4fdd72a4&scoped=true"
import script from "./DashboardPlaceholder.vue?vue&type=script&lang=js"
export * from "./DashboardPlaceholder.vue?vue&type=script&lang=js"

import "./DashboardPlaceholder.vue?vue&type=style&index=0&id=4fdd72a4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fdd72a4"]])

export default __exports__